class ThumbnailSlider {
	constructor(selector = ".service-slider") {
		this.slider = document.querySelector(selector)

		this.init()
	}

	init() {
		if (!this.slider || typeof Swiper === "undefined") {
			return
		}

		const slides = this.slider.querySelectorAll(".swiper-slide")
		const canLoop = slides.length > 3

		new Swiper(this.slider, {
			slidesPerView: "auto",
			spaceBetween: 18,
			loop: canLoop,
			speed: 700,

			navigation: {
				nextEl: this.slider.querySelector(".swiper-button-next"),
				prevEl: this.slider.querySelector(".swiper-button-prev")
			},

			autoplay: canLoop
				? {
						delay: 3500,
						disableOnInteraction: false
					}
				: false,

			breakpoints: {
				0: {
					spaceBetween: 12
				},

				768: {
					spaceBetween: 18
				},

				1200: {
					spaceBetween: 20
				}
			}
		})
	}
}

export default ThumbnailSlider